








































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { getNodesFlattenRecursive } from '@/core/components/tree/treeHelpers';
import DataSource from 'devextreme/data/data_source';
import DxTreeView from 'devextreme-vue/tree-view';
import { DxCustomRule, DxValidator } from 'devextreme-vue/validator';

@Component({
    components: {
        DxDropDownBox,
        DxTreeView,
        DxValidator,
        DxCustomRule,
    },
})
export default class TreeDropDown extends Vue {
    @Prop({ type: String, required: false, default: null }) public items!:
        | any
        | null;
    @Prop({ type: Boolean, required: false, default: true })
    public multiselect!: boolean;
    @Prop({ type: Boolean, required: false, default: false })
    public requiredRule!: boolean;

    @Prop({ type: String, required: false }) public placeholder!: string;
    @Prop({ type: String, required: false, default: null })
    public validationGroupName!: string;
    @Prop({ type: String, required: false, default: 'treeId' })
    public keyExpr!: string;
    @Prop({ type: String, required: false, default: 'treeId' })
    public valueExpr!: string;
    @Prop({ type: String, required: false, default: 'name' })
    public displayExpr!: string;

    @Prop({ type: Function, required: true }) public loadSelectedItems?: (
        items: any
    ) => Promise<any[]>;
    @Prop({ type: Function, required: true }) public load?: (
        items: any
    ) => Promise<any[]>;

    public preSelectedItems: any[] = [];
    public selectedItems: any[] = [];

    public get selectedAliases() {
        let allItems = this.selectedItems;
        allItems = allItems.concat(this.preSelectedItems);

        const distinctItems = allItems.filter((item, i, arr) => {
            return arr.indexOf(arr.find(t => t.alias === item.alias)!) === i;
        });

        return distinctItems.length > 0
            ? distinctItems.map((item: any) => item.alias)
            : null;
    }

    public get preSelectedAliases() {
        return this.preSelectedItems.map((item: any) => item.alias);
    }

    public get getAliases() {
        return this.selectedAliases ? this.selectedAliases.join(',') : false;
    }

    public validateInput() {
        const validation = this.validate();
        this.dropDown.validationStatus = validation ? undefined : 'invalid';
        return validation;
    }

    public clearSelection() {
        this.selectedItems = [];
        this.preSelectedItems = [];
        this.selected();
    }

    private get dataSource() {
        return new DataSource({
            loadMode: 'processed',
            key: this.keyExpr,
            load: this.load,
        });
    }

    private validate() {
        return !this.selectedAliases || this.selectedAliases?.length === 0
            ? false
            : true;
    }

    private get selectedNames(): string[] {
        let allItems = this.selectedItems;
        allItems = allItems.concat(this.preSelectedItems);

        const distinctItems = allItems.filter((item, i, arr) => {
            return arr.indexOf(arr.find(t => t?.alias === item?.alias)!) === i;
        });

        return distinctItems.map((item: any) => {
            return item.name;
        });
    }

    private async mounted() {
        if (this?.items && this.loadSelectedItems) {
            this.preSelectedItems = await this.loadSelectedItems(this.items);
        }
    }

    private get dropDown() {
        const name = 'drop-down';
        return this.$refs['tree-list'] as DxDropDownBox;
    }

    private get treeInstance(): any {
        const element = this.$refs['tree-list'] as unknown;
        let instance = null;
        if (element) {
            instance = (element as DxTreeView)!.instance!;
        }
        return instance;
    }

    private get selectionMode() {
        return this.multiselect ? 'multiple' : 'single';
    }

    private get showCheckBoxesMode() {
        return this.multiselect ? 'normal' : 'none';
    }

    private itemSelectionChanged(e: any) {
        this.selectedItems = e.component.getSelectedNodes().map((item: any) => {
            return item.itemData;
        });

        if (this.multiselect) {
            this.preSelectedItems.forEach((item: any) => {
                this.selectedItems.push(item);
            });
        } else {
            this.preSelectedItems = [];
        }
    }

    private selected() {
        if (this.multiselect) {
            this.$emit('onSelect', this.selectedAliases);
        } else {
            this.$emit('onSelect', this.getAliases);
        }
    }

    private syncTreeViewSelection(e: any) {
        const treeView =
            (e.component.selectItem && e.component) || this.treeInstance;

        if (
            e.component.NAME &&
            e.component.NAME === 'dxDropDownBox' &&
            e.value === null
        ) {
            this.clearSelection();
            return;
        }

        if (treeView) {
            const nodes = getNodesFlattenRecursive(
                this.treeInstance.getNodes()
            );
            if (
                this.selectedItems.length === 0 &&
                this.preSelectedItems.length === 0
            ) {
                this.treeInstance.unselectAll();
            } else {
                const values = this.selectedAliases;
                if (values) {
                    values.forEach((value: any) => {
                        if (this.multiselect) {
                            nodes
                                .filter((n: any) => n.alias === value)!
                                .forEach((node: any) => {
                                    const foundIndex = this.preSelectedAliases.indexOf(
                                        node.alias
                                    );
                                    if (foundIndex > -1) {
                                        this.preSelectedItems.splice(
                                            foundIndex,
                                            1
                                        );
                                    }
                                    treeView.selectItem(node.treeId);
                                });
                        } else {
                            const nodeId = nodes.filter(
                                (n: any) => n.alias === value
                            )![0]
                                ? nodes.filter(
                                      (n: any) => n.alias === value
                                  )![0].treeId
                                : null;
                            if (nodeId) {
                                treeView.selectItem(nodeId);
                            }
                        }
                    });
                }
            }
        }
    }
}
